// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
//import App from './App';

import NauPage from './NauPage';

//import DynamicForm from './DynamicForm'
import { router } from './router'

import VueMask from 'v-mask'
import Vuelidate from 'vuelidate';
import Vuex from 'vuex';


// bootstrap vue components
import { BootstrapVue } from 'bootstrap-vue';


import vuetify from '@/plugins/vuetify';
import LoanParams from '@/plugins/loan-params';

import Toasted from 'vue-toasted';


import LogService from '@/logService';
import __CFG from '@/conf/config.json';


// Inicjalizacja LogService PRZED utworzeniem Vue instance
LogService.init(__CFG.primaryEndpoint);
window.LogService = LogService;


// message bus
export const bus = new Vue();



import common from '@/mixins/common';
Vue.mixin(common);



Vue.use(LoanParams);

Vue.use(VueMask);
Vue.use(Vuelidate);

Vue.use(Vuex);
Vue.use(BootstrapVue);



Vue.use(Toasted);

// uuid generator
window.uuidv4 = function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


//initialize sid
if ( localStorage.getItem('sid') ) {

  window.__sid = localStorage.getItem('sid');
}
else {

  window.__sid = window.uuidv4();

  localStorage.setItem('sid', window.__sid);
}



// fingerprint
import('../static/js/thumbmark.umd.js')
.then((thmb) => {

    thmb.getFingerprint().then((fp) => { 

      window.fingerprint = fp;
   //   console.log(fp)
    });


});





/** Vue Filters Start */
Vue.filter('truncate', function (text, length, suffix) {
    if (text.length > length) {
        return text.substring(0, length) + suffix;
    } else {
        return text;
    }
});
/** Vue Filters End */




Vue.config.productionTip = false

/* eslint-disable no-new */
let app = new Vue({
  //store: store,


  router,
  vuetify,


  computed: {

    mainpage() {

      return this.$children[0];
    }
  },



  methods: {

    onKeyPress(e) {
      if (e.keyCode === 116) {
        // f5
        this.log('refresh triggered - F5');
      }
    },

    onClick(e) {
      const target = e.target;
      if (
        target.tagName === 'A' ||
        (target.tagName === 'INPUT' && target.type === 'submit') ||
        target.tagName === 'BUTTON'
      ) {
        this.log('clicked ' + (target.innerText || target.value || target.tagName));
      }
    },

    onBeforeUnload(e) {
      this.log('page leave');
    },

    onPageError(e) {
      this.log('page error', e.message, ' line ', e.lineno, ' error ', e.error);
    },

    visibilityChanged(e) {
      if (document.visibilityState === 'hidden') {
        this.log('page visibility hidden');
      }
      else if (document.visibilityState === 'visible') {
        this.log('page visibility visible');
      }
    }

  },



  mounted() {

    document.addEventListener('visibilitychange', this.visibilityChanged, true);
    document.addEventListener('keypress', this.onKeyPress);
    document.addEventListener('click', this.onClick);
    window.addEventListener('beforeunload', this.onBeforeUnload, true);
    window.addEventListener('error', this.onPageError, true);

  },


  render: h => h( NauPage ),
});


// keep main vue instance reference
window.APP = app;


app.$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js